//Type
export const PAY_IN = 1;
export const PAY_OUT = 2;

//PayIn transaction status
export const TRANSACTION_INITIATED = 0;
export const TRANSACTION_PROCESSING = 1;
export const TRANSACTION_SUCCESS = 2;
export const TRANSACTION_REJECTED = 3;
export const TRANSACTION_CANCELLED = 4;
export const TRANSACTION_FAILED = 5;
export const TRANSACTION_CHARGEBACK = 6;
export const TRANSACTION_DISCREPANCY = 7;

//PayOut deposit status
export const PAYOUT_DEPOSIT_INITIATED = 1;
export const PAYOUT_DEPOSIT_INPROGRESS = 2;
export const PAYOUT_DEPOSIT_COMPLETED = 3;
export const PAYOUT_DEPOSIT_FAILED = 4;

//PayOut type
export const PAY_OUT_TYPE_ZYRO = 1;
export const PAY_OUT_TYPE_HAODA = 2;
export const PAY_OUT_TYPE_AXIS = 3;
export const PAY_OUT_TYPE_HAODA_BANK = 4;
export const PAY_OUT_TYPE_V2C = 5;
export const PAY_OUT_TYPE_DIASPAY = 6;
export const PAY_OUT_TYPE_TRANSXT_UPI = 7;
export const PAY_OUT_TYPE_TRANSXT_IMPS = 8;
export const PAY_OUT_TYPE_SINAURATEK_IMPS = 9;
export const PAY_OUT_TYPE_SINAURATEK_UPI = 10;
export const PAY_OUT_TYPE_TRANSXT_NEFT = 11;
export const PAY_OUT_TYPE_TRANSXT_RTGS = 12;
export const PAY_OUT_TYPE_SINAURATEK_NEFT = 13;
export const PAY_OUT_TYPE_SINAURATEK_RTGS = 14;
export const PAY_OUT_TYPE_RNR_C_IMPS = 15;
export const PAY_OUT_TYPE_RNR_P_IMPS = 16;
export const PAY_OUT_TYPE_RNR_3_IMPS = 17;
export const PAY_OUT_TYPE_RNR_4_IMPS = 18;
export const PAY_OUT_TYPE_RNR_5_IMPS = 19;
export const PAY_OUT_TYPE_SINA_C_IMPS = 20;
export const PAY_OUT_TYPE_SINA_P_IMPS = 21;
export const PAY_OUT_TYPE_SINA_3_IMPS = 22;
export const PAY_OUT_TYPE_SINA_4_IMPS = 23;
export const PAY_OUT_TYPE_SINA_5_IMPS = 24;
export const PAY_OUT_TYPE_FUTURA_IMPS = 25;
export const PAY_OUT_TYPE_PROCLOUD_IMPS = 26;

//PayOut transaction status
export const PAYOUT_INITIATED = 1;
export const PAYOUT_INPROGRESS = 2;
export const PAYOUT_COMPLETED = 3;
export const PAYOUT_FAILED = 4;
export const PAYOUT_REFUNDED = 5;
